import React, { useState } from "react";
import { MapProvider } from "@gis/components/Context";
import BaseMap from "@gis/components/BaseMap";
import { useSelector } from "react-redux";
import GenericMarker from "../components/GenericMarker";
import marker_info from "../assets/images/logo/marker_in.svg";

export const GisMapWrapper = ({ center, zoom, children, hideLatLon = true }: { center: [number, number] | [any, any] | undefined, zoom: number, children: any, hideLatLon?: boolean }) => {

    const [zoomLevel, setZoomLevel] = useState(zoom);
    const [centerPoint, setCenterPoint] = useState(center);

    const { searchCoordinates } = useSelector((state: any) => state.gisData);

    React.useEffect(() => {
        setCenterPoint(center);
        setZoomLevel(zoom);
    }, [zoomLevel, center])

    return (
        <>
            <div className="relative" style={{ width: "100%", height: "100%" }}>
                <MapProvider center={centerPoint} zoom={zoomLevel}>
                    <BaseMap width="100%" height="100%" hideLatLon={hideLatLon} />
                    {children}
                    {searchCoordinates?.longitude !== 0 && (
                        <GenericMarker
                            coordinates={[
                                Number(searchCoordinates?.longitude) || 0,
                                Number(searchCoordinates?.latitude) || 0,
                            ]}
                            size={1.5}
                            anchor={[0.5, 1]}
                            img={marker_info}
                        />
                    )}
                </MapProvider>
            </div>
        </>
    );
}